import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivateHealthStepParams } from './types'
import { insuranceTypeSchema } from './types'

export const insuranceType = (params: PrivateHealthStepParams) => {
  const schema = insuranceTypeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privateHealth:steps.currently_covered.title',
        },
      },
      {
        type: 'choice',
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.currently_covered.options.private',
            },
            value: 'private',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.currently_covered.options.public',
            },
            value: 'public',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_privateHealth:steps.currently_covered.options.none',
            },
            value: 'none',
          },
        ],
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('insurance_type'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'employment_status',
    subFlow: SubFlow.PrivateHealth,
  } as const satisfies AnyStepConfiguration
}
